import type { LessonType } from "@prisma/client";
import { lessonTypeToModality, type Modality } from "@lib/learner/modality/modality";

/**
 * The tint family for each skill spoke.
 *
 * Four components carried their own copy of this table, keyed variously by
 * Modality or by LessonType - the two names for the same four spokes, differing
 * only in that DICTATION lessons practice LISTENING. Rename a design token and
 * all four had to be found. hubTints held the listening accent twice on its own.
 *
 * Class names are written out in full: Tailwind v4 scans source for literal
 * class strings, so `bg-${token}-tint` would compile and then render unstyled.
 */
export const MODALITY_TINT = {
  READING: "bg-reading-tint text-reading-fg",
  WRITING: "bg-writing-tint text-writing-fg",
  SPEAKING: "bg-speaking-tint text-speaking-fg",
  LISTENING: "bg-listening-tint text-listening-fg",
} as const satisfies Record<Modality, string>;

/** Left-edge accent bar in the spoke's colour. */
export const MODALITY_ACCENT = {
  READING: "border-l-4 border-reading",
  WRITING: "border-l-4 border-writing",
  SPEAKING: "border-l-4 border-speaking",
  LISTENING: "border-l-4 border-listening",
} as const satisfies Record<Modality, string>;

export function lessonTypeTint(type: LessonType): string {
  return MODALITY_TINT[lessonTypeToModality(type)];
}

export function modalityAccent(modality: Modality): string {
  return MODALITY_ACCENT[modality];
}

export function lessonTypeAccentClass(type: LessonType): string {
  return MODALITY_ACCENT[lessonTypeToModality(type)];
}
